import styled, { css } from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";
import type { StyledTabButtonProps } from "./TabButton.model";

interface Props extends StyledTabButtonProps {
  theme: ElearningTheme;
}

export const StyledTabButton = styled.div<Props>`
  padding: 8px 16px;
  border-radius: 32px;
  margin-right: 8px;
  border: 2px solid  ${(props: Props) => props.theme.palette.neutral._10};
  color: ${(props: Props) => props.theme.palette.neutral._400};
  cursor: pointer;
  ${(props: Props) =>
    props.$isActive &&
    css`
  border: 2px solid  ${props.theme.palette.secondary.brand};
  background-color: ${props.theme.palette.secondary.brand};
  .content {
    color: ${props.theme.palette.neutral.white};
  }
;
`}
`;
